import { CloudDownload, Print } from "@mui/icons-material";
import { Box, Button, Card, FormLabel, Grid, Icon, MenuItem, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, styled } from "@mui/material";
import { Loader } from "app/components";
import { getBMLItemsForReport, getWorkerAttendanceReport } from "app/redux/actions/ReportsAction";
import { getAllProjectLocationByAgency, getAllResourceRequisitionByProjectLocation } from "app/redux/actions/ResourceForeCastActions";
import { AppConstants } from "app/utils/AppConstants";
import { SnackBarProperty } from "app/utils/SnackBarProperty";
import { SimpleCard } from "components";
import jsPDF from "jspdf";
import "jspdf-autotable";
import moment from "moment";
import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { useDispatch, useSelector } from "react-redux";

const Container = styled("div")(({ theme }) => ({
  margin: "30px",
  [theme.breakpoints.down("sm")]: { margin: "16px" },
  "& .breadcrumb": {
    marginBottom: "30px",
    [theme.breakpoints.down("sm")]: { marginBottom: "16px" },
  },
}));

const styles = {
  tableCell: {
    textAlign: "center"
  },
  subHeader: {
    textAlign: "center",
    fontWeight: 700
  }

}
const DecoratedTextField = styled(TextValidator)(() => ({
  width: "100%",
  marginBottom: "16px",
}));

export const WorkerAttendanceReport = () => {
  const dispatch = useDispatch();
  const [isDownloading, setIsDownloading] = useState(false)
  const [isPrinting, setIsPrinting] = useState(false)
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [requisitionList, setRequisitionList] = useState()
  const [bmlItemsList, setBmlItemsList] = useState()
  const { projectLocationListForAgency, resourceForecastList } = useSelector((state) => state?.resourceForecast)
  const [tableData, setTableData] = useState([])
  const months =
    [
      {
        value: 1,
        month: "January",
        max: 31
      },
      {
        value: 2,
        month: "February",
        max: 30
      },
      {
        value: 3,
        month: "March",
        max: 31
      },
      {
        value: 4,
        month: "April",
        max: 30
      },
      {
        value: 5,
        month: "May",
        max: 31
      },
      {
        value: 6,
        month: "June",
        max: 30
      },
      {
        value: 7,
        month: "July",
        max: 31
      },
      {
        value: 8,
        month: "August",
        max: 31
      },
      {
        value: 9,
        month: "September",
        max: 30
      },
      {
        value: 10,
        month: "October",
        max: 31
      },
      {
        value: 11,
        month: "November",
        max: 30
      },
      {
        value: 12,
        month: "December",
        max: 31
      }]

  const [state, setState] = useState({
    project_location_id: '',
  })


  useEffect(() => {
    dispatch(getAllProjectLocationByAgency(showLoader, hideLoader, showToast))
  }, []);

  const showLoader = () => {
    setLoading(true)
  }
  const showToast = (message, type) => {
    const key = enqueueSnackbar(message ? message : AppConstants.somethingWentWrong, { variant: type === "info" ? "info" : 'error' });
    type === "info" ? SnackBarProperty.info(key, closeSnackbar) : SnackBarProperty.error(key, closeSnackbar)

  }

  const hideLoader = () => {
    setLoading(false)
  }

  const handleChange = (event, source) => {

    if (event.target.name === "project_location_id") {
      setTableData([])
      const filteredArray = projectLocationListForAgency.filter(project => {
        return project.project_location_id === event.target.value
      });


      setState({
        [event.target.name]: event.target.value,
        project_name: filteredArray[0].project_name,
        project_location_id: filteredArray[0].project_location_id,
        project_id: filteredArray[0].project_id,
        project_location: filteredArray[0].project_location

      });
      setLoading(true)
      getAllResourceRequisitionByProjectLocation({ project_location_id: event.target.value }).then(res => {
        setLoading(false)

        if (res?.status < 300) {
          if (res?.data?.obj?.length > 0) {
            //setRequisitionList(res?.data?.obj)
            // Filter the data based on resourceforecast_category_id equal to 3
            const filteredData = res.data.obj.filter(item => item.resourceforecast_category_id === 1);

            // Set the filtered data to the requisitionList state
            setRequisitionList(filteredData);
          }
          else {
            const key = enqueueSnackbar("No requisition found", { variant: 'info' });
            SnackBarProperty.info(key, closeSnackbar);
          }


        }
        else {
          const key = enqueueSnackbar(res?.data?.message, { variant: 'error' });
          SnackBarProperty.error(key, closeSnackbar);

        }
      }).catch(err => {
        setLoading(false)
        const key = enqueueSnackbar(err?.response?.data?.errorMessage ?? AppConstants.somethingWentWrong, { variant: 'error' });
        SnackBarProperty.error(key, closeSnackbar);

      })

    }
    else if (event.target.name === "requisition_id") {
      setTableData([])
      const filteredArray = requisitionList.filter(requisition => {
        return requisition.resourcerequisition_id === event.target.value
      });
      setState({
        ...state, [event.target.name]: event.target.value,
        req_month: months[filteredArray[0].req_month - 1],
        req_no: filteredArray[0].requisition_no,
        req_date: moment(filteredArray[0].requisition_date).format("DD-MM-YYYY"),
        req_year: filteredArray[0].req_year,
        category: filteredArray[0].resourceforecast_category_name
      });
      setLoading(true)
      getBMLItemsForReport(event.target.value).then(res => {
        setLoading(false)
        if (res?.status < 300) {
          if (res?.data?.success) {
            if (res?.data?.obj?.item?.length > 0) {
              setBmlItemsList(res?.data?.obj?.item)
            }
            else {
              const key = enqueueSnackbar("No BML items found", { variant: 'info' });
              SnackBarProperty.info(key, closeSnackbar);
            }
          }
          else {
            const key = enqueueSnackbar(res?.data?.message, { variant: 'info' });
            SnackBarProperty.info(key, closeSnackbar);
          }
        }
        else {
          const key = enqueueSnackbar(res?.data?.message, { variant: 'error' });
          SnackBarProperty.error(key, closeSnackbar);

        }
      }).catch(err => {
        setLoading(false)
        const key = enqueueSnackbar(err?.response?.data?.errorMessage ?? AppConstants.somethingWentWrong, { variant: 'error' });
        SnackBarProperty.error(key, closeSnackbar);

      })
    }
    else {
      setTableData([])
      setState({ ...state, [event.target.name]: event.target.value })
    }
  }


  const handleFormSubmit = () => {
    setTableData([])
    if (state.year === undefined || state.year === null) {
      const key = enqueueSnackbar("Please enter year", { variant: 'error' });
      SnackBarProperty.error(key, closeSnackbar);
    }
    else if (state?.year && state?.year?.toString()?.length === 4) {
      setLoading(true)
      const params = {
        project_location_id: state?.project_location_id,
        resourcerequisition_id: state?.requisition_id,
        month: state?.month,
        year: parseInt(state?.year),
        resourcerequisition_details_id: 0 //state?.resourcerequisition_details_id

      }
      getWorkerAttendanceReport(params).then(res => {
        setLoading(false)
        if (res?.status < 300 && res?.data?.success) {
          if (res?.data?.obj?.item?.worker_attendance_report && Object.keys(res?.data?.obj?.item?.worker_attendance_report)?.length > 0) {
            const transformedTableData = Object.keys(res?.data?.obj?.item?.worker_attendance_report).map(workerName => {
              const checkedMonth = months?.filter(elem => state?.month === elem?.value)
              console.log("checked month:", checkedMonth)
              const attendance = []
              let increaseFeb = false
              // if(((parseInt(state?.year) % 4 === 0 && parseInt(state?.year) % 100 !== 0) || (parseInt(state?.year) % 400 === 0))&&state?.month===2){

              //   console.log("error occured")
              //   increaseFeb=true
              // }
              for (let i = 1; i <= checkedMonth[0]?.max; i++) {
                let matched = "na"
                res?.data?.obj?.item?.worker_attendance_report[workerName]?.forEach(elem => {
                  if (parseInt(moment(elem?.attendance_date).date()) === i) {
                    if (elem?.is_present === true) {
                      // attendance.push({text:"P",count:1})
                      matched = "pr"
                    }
                    else if (elem?.is_present === false) {
                      // attendance.push({text:"P",count:1})
                      matched = "ab"
                    }
                    else {
                      matched = "na"
                    }
                  }
                })
                if (matched === "pr") {
                  attendance.push({ text: "P", count: 1 })
                }
                else if (matched === "ab") {
                  attendance.push({ text: "A", count: 1 })
                }
                else {
                  attendance.push({ text: "-", count: 1 })
                }

              }
              return {
                name: workerName,
                details: attendance,
                category: res?.data?.obj?.item?.worker_attendance_report?.[workerName]?.[0]?.category
              }
            });
            setTableData(transformedTableData)
          }
          else {
            const key = enqueueSnackbar("No worker attendance details found", { variant: 'info' });
            SnackBarProperty.info(key, closeSnackbar);
          }

        }
        else {
          const key = enqueueSnackbar(res?.data?.message, { variant: 'error' });
          SnackBarProperty.error(key, closeSnackbar);

        }
      }).catch(err => {
        console.log("error1:", err)
        setLoading(false)
        const key = enqueueSnackbar(err?.response?.data?.errorMessage ?? AppConstants.somethingWentWrong, { variant: 'error' });
        SnackBarProperty.error(key, closeSnackbar);

      })
    }
    else {
      const key = enqueueSnackbar("Please enter valid year", { variant: 'error' });
      SnackBarProperty.error(key, closeSnackbar);
    }

  }


  const getTotalPresent = (index) => {
    const sumOfP = tableData[index]?.details?.reduce((acc, item) => {
      if (item.text === "P") {
        acc += item.count;
      }
      return acc;
    }, 0);
    return sumOfP
  }
  const getTotalAbsent = (index) => {
    const sumOfA = tableData[index]?.details?.reduce((acc, item) => {
      if (item.text === "A") {
        acc += item.count;
      }
      return acc;
    }, 0);
    return sumOfA
  }

  useEffect(() => {
    if (tableData?.length > 0) {
      console.log("details:", tableData)
    }
  }, [tableData])


  const handleReportDownload = (isPrint) => {
    if (!tableData?.length) {
      const key = enqueueSnackbar("No data available to export", { variant: "info" });
      SnackBarProperty.info(key, closeSnackbar);
      return;
    }

    const doc = new jsPDF({ orientation: "landscape", unit: "pt", format: "a4" });
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const marginX = 20;

    if (isPrint) {
      setIsPrinting(true);
      setIsDownloading(false);
    } else {
      setIsPrinting(false);
      setIsDownloading(true);
    }

    const selectedMonth = months?.find((elem) => elem?.value === state?.month);
    const dayCount = selectedMonth?.max ?? 0;

    const drawHeader = (pageNumber) => {
      doc.setTextColor(17, 58, 93);
      doc.setFont("helvetica", "bold");
      doc.setFontSize(16);
      doc.text("Worker Attendance Report", pageWidth / 2, 42, { align: "center" });

      doc.setFont("helvetica", "normal");
      doc.setFontSize(8.5);
      doc.setTextColor(70, 80, 90);
      const leftColX = marginX + 8;
      const rightColX = pageWidth / 2 + 4;

      doc.setFont("helvetica", "bold");
      doc.text("Project Location:", leftColX, 62);
      doc.setFont("helvetica", "normal");
      doc.text(state?.project_location || "-", leftColX + 78, 62);

      doc.setFont("helvetica", "bold");
      doc.text("Project Name:", rightColX, 62);
      doc.setFont("helvetica", "normal");
      doc.text(state?.project_name || "-", rightColX + 70, 62);

      doc.setFont("helvetica", "bold");
      doc.text("Project ID:", leftColX, 76);
      doc.setFont("helvetica", "normal");
      doc.text(state?.project_id || "-", leftColX + 54, 76);

      doc.setFont("helvetica", "bold");
      doc.text("Month:", rightColX, 76);
      doc.setFont("helvetica", "normal");
      doc.text(selectedMonth?.month || "-", rightColX + 42, 76);

      doc.setFont("helvetica", "bold");
      doc.text("Year:", leftColX, 90);
      doc.setFont("helvetica", "normal");
      doc.text(state?.year || "-", leftColX + 30, 90);

      doc.setFont("helvetica", "bold");
      doc.text("Present:", rightColX, 90);
      doc.setFont("helvetica", "normal");
      doc.text("P", rightColX + 46, 90);
      doc.setFont("helvetica", "bold");
      doc.text("Absent:", rightColX + 60, 90);
      doc.setFont("helvetica", "normal");
      doc.text("A", rightColX + 100, 90);

      doc.setDrawColor(210, 218, 226);
      doc.setLineWidth(0.4);
      doc.line(marginX, 104, pageWidth - marginX, 104);

     
    };

    /*const drawFooter = (pageNumber) => {
      doc.setFont("helvetica", "normal");
      doc.setFontSize(8);
      doc.setTextColor(100, 100, 100);
      doc.text(`Generated on ${moment().format("DD-MM-YYYY HH:mm")}`, marginX, pageHeight - 20);
      doc.text(`Page ${pageNumber}`, pageWidth - marginX, pageHeight - 20, { align: "right" });
    };*/

    const body = [];
    tableData?.forEach((elem, index) => {
      const row = [index + 1, elem?.category ?? "", elem?.name ?? ""];
      elem?.details?.forEach((item) => row.push(item?.text ?? "-"));
      row.push(getTotalPresent(index));
      row.push(getTotalAbsent(index));
      body.push(row);
    });

    const headers = [
      "SL No.",
      "Category",
      "Worker Name",
      ...Array.from({ length: dayCount }, (_, index) => index + 1),
      "Total (P)",
      "Total (A)",
    ];

    doc.autoTable({
      startY: 112,
      margin: { top: 112, bottom: 34, left: marginX, right: marginX },
      head: [headers],
      body,
      theme: "grid",
      pageBreak: "auto",
      showHead: "everyPage",
      styles: {
        fontSize: 8,
        cellPadding: 2,
        textColor: [40, 40, 40],
        lineColor: [200, 200, 200],
        lineWidth: 0.25,
        overflow: "linebreak",
      },
      headStyles: {
        fillColor: [18, 91, 158],
        textColor: [255, 255, 255],
        fontStyle: "bold",
        halign: "center",
      },
      columnStyles: {
        0: { cellWidth: 28, halign: "center" },
        1: { halign: "left" },
        2: { halign: "left" },
        ...Object.fromEntries(
          Array.from({ length: dayCount }, (_, index) => [index + 3, { cellWidth: 14, halign: "center" }])
        ),
        [dayCount + 3]: { cellWidth: 34, halign: "center" },
        [dayCount + 4]: { cellWidth: 34, halign: "center" },
      },
      didDrawPage: (data) => {
        drawHeader(data.pageNumber);
        // drawFooter(data.pageNumber);
      },
    });

    const pdfBlob = doc.output("blob", { scale: 1.0 });
    const pdfUrl = URL.createObjectURL(pdfBlob);

    if (isPrint) {
      const newWindow = window.open(pdfUrl, "_blank");
      URL.revokeObjectURL(pdfUrl);
      if (newWindow) {
        newWindow.onload = () => {
          setIsPrinting(false);
          setIsDownloading(false);
          newWindow.print();
        };
      }
    }

    setIsPrinting(false);
    setIsDownloading(false);

    if (!isPrint) {
      doc.save("Worker_Attendance_Report.pdf");
    }
  };
  // const checkLeapYear=(year)=> {
  //   // Leap years are divisible by 4
  //   // But if a year is divisible by 100, it must also be divisible by 400 to be a leap year
  //   if((year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0)){
  //     return true
  //   }
  //   // return(year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0)
  //   else{
  //     return false
  //   }

  // }

  return (
    <>
      <Container>
        <div style={{ height: 'auto', width: "100%", display: "flex", flexDirection: "column", gap: "20px" }}>

          <Grid container>

            <Grid item xs={12}>
              <Button
                size="small"
                sx={{ width: "100px" }}
                variant="contained"
                color="error"
                onClick={() => { window.history.back() }}
              >
                <Icon color="primary" fontSize="small">
                  skip_previous
                </Icon>
                Back
              </Button>
            </Grid>
          </Grid>
          <SimpleCard>

            <ValidatorForm onSubmit={handleFormSubmit}>
              <Grid container spacing={3} style={{ marginTop: '-45px', marginBottom: '15px' }} >
                <Grid item xs={12}><b className="font20 extraBold" style={{ color: "#ebad4e" }}>Worker Attendance</b></Grid>
              </Grid>
              <Grid container spacing={3}>

                <Grid item sm={4} xs={12}>
                  <DecoratedTextField
                    select
                    size="small"
                    fullWidth
                    sx={{ mb: 3 }}
                    label="Project ID"
                    id="project_location_id"
                    variant="outlined"
                    name="project_location_id"
                    value={state?.project_location_id}
                    onChange={handleChange}
                    validators={["required"]}
                    errorMessages={["Project ID is required"]}
                  >
                    {projectLocationListForAgency?.map((item) => (
                      <MenuItem value={item?.project_location_id} key={item?.project_id}>
                        {item?.project_id}
                      </MenuItem>
                    ))}
                  </DecoratedTextField>
                </Grid>
                <Grid item sm={6} xs={12}>
                  <DecoratedTextField
                    select
                    size="small"
                    fullWidth
                    sx={{ mb: 3 }}
                    label="Requisition No."
                    id="requisition_id"
                    variant="outlined"
                    name="requisition_id"
                    value={state?.requisition_id}
                    onChange={handleChange}
                    validators={["required"]}
                    errorMessages={["Requisition Id is required"]}
                  >
                    {requisitionList?.map((item) => (
                      <MenuItem value={item?.resourcerequisition_id} key={item?.resourcerequisition_id}>
                        {item?.requisition_no}
                      </MenuItem>
                    ))}
                  </DecoratedTextField>

                </Grid>
              </Grid>

              <Grid container spacing={3}>
                {/* <Grid item lg={4} md={6} sm={6} xs={12}>
                  <DecoratedTextField
                    select
                    size="small"
                    fullWidth
                    sx={{ mb: 3 }}
                    label="BML Item"
                    id="resourcerequisition_details_id"
                    variant="outlined"
                    name="resourcerequisition_details_id"
                    value={state?.resourcerequisition_details_id}
                    onChange={handleChange}
                    validators={["required"]}
                    errorMessages={["BML Item is required"]}
                  >
                    {bmlItemsList?.map((item) => (
                      <MenuItem value={item?.resourcerequisition_details_id} key={item?.resourcerequisition_id}>
                        {item?.bml_item}
                      </MenuItem>
                    ))}
                  </DecoratedTextField>

                </Grid> */}
                <Grid item sm={4} xs={12}>
                  <DecoratedTextField
                    select
                    size="small"
                    fullWidth
                    sx={{ mb: 3 }}
                    label="Month"
                    id="month"
                    variant="outlined"
                    name="month"
                    value={state?.month}
                    onChange={handleChange}
                    validators={["required"]}
                    errorMessages={["Month is required"]}
                  >
                    {months?.map((item) => (
                      <MenuItem value={item?.value} key={item?.value}>
                        {item?.month}
                      </MenuItem>
                    ))}
                  </DecoratedTextField>

                </Grid>
                <Grid item sm={4} xs={12}>
                  <TextField
                    type="number"
                    size="small"
                    fullWidth
                    name="year"
                    id="year"
                    label="Year"
                    value={state?.year || ""}
                    onChange={handleChange}
                    validators={["required"]}
                    errorMessages={["Year is required"]}
                    onKeyDown={(event) => {
                      if (event?.code === "ArrowDown" || event?.code === "ArrowUp" ||
                        event?.key === "-" || event?.key === "+" || event?.key === "." || event?.key?.toLowerCase() === "e") {
                        event.preventDefault();
                      }

                    }}
                  />

                </Grid>

                <Grid item sm={4} sx={{ display: "flex", justifyContent: "flex-start", alignItems: "center" }}>

                  <Button size="medium" color="success" variant="contained" type="submit" style={{ marginTop: -20 }} >View</Button>

                </Grid>

              </Grid>

            </ValidatorForm>
          </SimpleCard>
          {
            tableData && tableData?.length > 0 &&
            <Grid container>
              <Grid item xs={12}>
                <Box component="span" display="flex" justifyContent="flex-end">
                  <Button
                    size="small"
                    sx={{ width: "130px", marginLeft: 4 }}
                    variant="contained"
                    color="warning"
                    startIcon={<CloudDownload />}
                    onClick={() => { handleReportDownload(false) }}
                  >
                    Download
                  </Button>
                  <Button
                    size="small"
                    sx={{ width: "100px", marginLeft: 2 }}
                    variant="contained"
                    color="primary"
                    startIcon={<Print />}
                    onClick={() => { handleReportDownload(true) }}
                  >
                    Print
                  </Button>
                </Box>
              </Grid>

            </Grid>}
          {/* table */}
          {
            tableData && tableData?.length > 0 &&
            <Card sx={{ padding: 3 }}>

              <div style={{ width: "100%", display: 'flex', flexDirection: "column", gap: "50px" }}>
                <div id="header" style={{ width: "100%", display: 'flex', flexDirection: "column", gap: "50px" }}>
                  
                  <Grid item xs={12} align='center' >
                    <FormLabel sx={{ fontSize: 22 }} ><b>Worker Attendance Report</b></FormLabel>
                  </Grid>


                  <Grid container >
                    <Grid item xs={12} sx={{ marginTop: 2 }}>
                      <FormLabel sx={{ fontSize: 18 }}><b>Project Location: </b>{state?.project_location}</FormLabel>
                    </Grid>
                    <Grid item xs={12} sx={{ marginTop: 2 }}>
                      <FormLabel sx={{ fontSize: 18 }}><b>Project Name: </b>{state?.project_name}</FormLabel>
                    </Grid>
                    <Grid item xs={12} sx={{ marginTop: 2 }}>
                      <FormLabel sx={{ fontSize: 18 }}><b>Project ID: </b>{state?.project_id}</FormLabel>
                    </Grid>
                    <Grid item xs={12} sx={{ marginTop: 2 }}>
                      <FormLabel sx={{ fontSize: 18 }}><b>Requisition No.: </b></FormLabel>&nbsp;&nbsp;&nbsp;
                      <FormLabel sx={{ fontSize: 18 }}><b>Requisition Date: </b></FormLabel>
                    </Grid>
                    <Grid item xs={12} sx={{ marginTop: 2 }}>
                      <FormLabel sx={{ fontSize: 18 }}><b>Month: </b>{months?.filter(elem => elem?.value === state?.month)?.[0]?.month}</FormLabel>
                      &nbsp;&nbsp;&nbsp;
                      <FormLabel sx={{ fontSize: 18 }}><b>Year: </b>{state?.year}</FormLabel>
                    </Grid>
                    <Grid item xs={12} sx={{ marginTop: 2 }}>
                      <FormLabel sx={{ fontSize: 18 }}><b>Absent:  A </b></FormLabel>&nbsp;&nbsp;&nbsp;
                      <FormLabel sx={{ fontSize: 18 }}><b>Present:  P </b></FormLabel>
                    </Grid>

                    {/* <Grid item xs={12} sx={{ marginTop: 2 }}>
            <FormLabel sx={{ fontSize: 18 }}><b>Requisition Month: </b>{state?.req_month}</FormLabel>
          </Grid>
          <Grid item xs={12} sx={{ marginTop: 2 }}>
            <FormLabel sx={{ fontSize: 18 }}><b>Requisition Year: </b>{state?.req_year}</FormLabel>
          </Grid>
          <Grid item xs={12} sx={{ marginTop: 2 }}>
            <FormLabel sx={{ fontSize: 18 }}><b>Category: </b>{state?.category}</FormLabel>
          </Grid> */}


                  </Grid>
                </div>

                <div id="tableData" style={{ overflowX: 'auto', minWidth: '750px' }}>
                  <TableContainer component={Paper}>
                    <Table>
                      <TableHead style={{ backgroundColor: '#87CEEB' }}>
                        <TableRow style={{ border: '1px solid #000' }}>
                          <TableCell align="center" style={{ border: '1px solid #000' }}>Sl No.</TableCell>
                          <TableCell align="left" width={150} style={{ border: '1px solid #000' }}>Category</TableCell>
                          <TableCell align="left" width={150} style={{ border: '1px solid #000' }}>Worker Name</TableCell>
                          {/* {
                    for(let i=1;i<=checkLeapYear(state?.year)&&state?.month===2?checkedMonth?.max+1:checkedMonth?.max;i++){
                        <TableCell align="center">Rate</TableCell>
                    }
                } */}
                          {Array.from({ length: months?.filter(mn => mn?.value === state?.month)[0]?.max }).map((_, index) => (
                            <TableCell align="center" style={{ border: '1px solid #000' }}>{index + 1}</TableCell>
                          ))}
                          <TableCell align="center" style={{ border: '1px solid #000' }}>Total(P)</TableCell>
                          <TableCell align="center" style={{ border: '1px solid #000' }}>Total(A)</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {
                          tableData?.map((elem, index) => {
                            return (
                              <TableRow style={{ borderRight: '1px solid #000' }}>
                                <TableCell align="center" style={{ border: '1px solid #000' }}>{index + 1}</TableCell>
                                <TableCell align="left" style={{ borderRight: '1px solid #000' }}>{elem?.category ?? ""}</TableCell>
                                <TableCell align="left" style={{ borderRight: '1px solid #000' }}>{elem?.name ?? ""}</TableCell>
                                {
                                  elem?.details?.map(item => {
                                    return (
                                      <TableCell align="center" style={{ borderRight: '1px solid #000' }}>{item?.text}</TableCell>
                                    )
                                  })
                                }
                                <TableCell align="right" style={{ borderRight: '1px solid #000' }}>{getTotalPresent(index)}</TableCell>
                                <TableCell align="right" style={{ borderRight: '1px solid #000' }}>{getTotalAbsent(index)}</TableCell>
                              </TableRow>
                            )
                          })


                        }
                        {/* <TableRow>
                      <TableCell colSpan={9} align="center"><b>Total Amount</b></TableCell>
                      <TableCell align="right">{formatNumberWithCommasAndDecimals(getTotalAmount() ? getTotalAmount() : 0)}</TableCell>
                    </TableRow> */}
                        {/* {tableData?.length > 0 &&
                <TableRow>
                  <TableCell colSpan={6} align="right"><b>Grand Total</b></TableCell>
                  <TableCell align="right"><b>{formatNumberWithCommasAndDecimals(totalAmount)}</b></TableCell>
                </TableRow>
              } */}

                      </TableBody>
                    </Table>
                  </TableContainer>

                </div>
              </div>
            </Card>}

        </div>
        {loading && (
          <Loader
            show={loading}
          />
        )}
        {(isPrinting || isDownloading) && (
          <Loader
            show={isPrinting ? isPrinting : isDownloading}
            text="Please Wait While Generating PDF..."
          />
        )}
      </Container>
    </>
  )
}